const initialState = {
  loading: false,
//  totalBurnin: 0,
//  paused: true,
//  onlyAllowlisted: true,
//  userBurnedAmount: 0,
//  tokensOfOwner: [],
//  burnedTokenIds: [],
  tokensOfOwner: [],
  tokensOfUserLocked: [],
  error: false,
  errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        //totalBurnin: action.payload.totalBurnin,
        //paused: action.payload.paused,
        //onlyAllowlisted: action.payload.onlyAllowlisted,
        //userBurnedAmount: action.payload.userBurnedAmount,
        //tokensOfOwner: action.payload.tokensOfOwner,
        //burnedTokenIds: action.payload.burnedTokenIds,
        tokensOfOwner: action.payload.tokensOfOwner,
        tokensOfUserLocked: action.payload.tokensOfUserLocked,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
